import api from './api';

export const checkAuth = async () => {
  try {
    const response = await api.get('/api/auth/me');
    return response.data;
  } catch (error) {
    console.error('Auth check error:', error);
    console.error('Error response:', error.response?.data);
    console.error('Error status:', error.response?.status);
    return { authenticated: false };
  }
};

export const login = () => {
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const oauthUrl = `${apiUrl}/api/auth/google`;
  console.log('Redirecting to OAuth:', oauthUrl);
  window.location.href = oauthUrl;
};

export const logout = async () => {
  try {
    await api.post('/api/auth/logout');
    window.location.href = '/admin/login';
  } catch (error) {
    console.error('Logout error:', error);
    window.location.href = '/admin/login';
  }
};




